import { FC, HTMLAttributes, memo, MouseEvent, useCallback } from 'react';
import cn from 'classnames';

import Link from '@Navigation/Link';
import UILink from '@UI/Link';
import { SellPointData } from '@Types/SellPoints';
import LocationIcon from './LocationIcon';
import styles from './SellPoint.module.css';

export interface SellPointProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  sellPoint: SellPointData;
  onClickMore?: (e: MouseEvent, sellPoint: SellPointData) => void;
}

const SellPoint: FC<SellPointProps> = ({ className, sellPoint, onClickMore }) => {
  const workTime = sellPoint.worktime?.join(' ');

  const handleClickLink = useCallback(
    (e) => {
      onClickMore(e, sellPoint);
    },
    [onClickMore, sellPoint],
  );

  return (
    <div className={cn(className, styles.wrapper)}>
      <div className={styles.infoBlock}>
        <LocationIcon className={styles.icon} />
        <div className={styles.textBlock}>
          <div
            className={styles.location}
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: sellPoint.address }}
          />
          <UILink
            className={styles.showOnMap}
            view='secondary'
            underlined
            onClick={handleClickLink}
          >
            Показать на карте
          </UILink>
        </div>
      </div>

      <div className={styles.contactsBlock}>
        <Link
          className={styles.phone}
          view='primary'
          to={`tel:+${sellPoint.phone.replace(/\D/g, '')}`}
        >
          {sellPoint.phone}
        </Link>
        <div>
          {workTime && (
            <div className={styles.workTime} dangerouslySetInnerHTML={{ __html: workTime }} />
          )}

          {sellPoint.holidaysSchedule?.length > 0 && (
            <>
              {sellPoint.holidaysSchedule.map((day, index) => (
                <div
                  key={index}
                  className={styles.holidays}
                  dangerouslySetInnerHTML={{ __html: day }}
                />
              ))}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default memo(SellPoint);
